/**
 * Utilidades para manejar subdominios
 */

export const getSubdomain = (): string | null => {
  const hostname = window.location.hostname
  
  // En desarrollo (localhost), no hay subdominios
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Puedes forzar el modo panel en dev con query param: ?panel=true
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('panel') === 'true' ? 'panel' : null
  }
  
  // En producción, detectar el subdomain
  const parts = hostname.split('.')
  
  // Si es solo dominio.com (2 partes) o dominio.co.do (3 partes con TLD compuesto)
  if (parts.length <= 2) {
    return null // No hay subdomain
  }
  
  // Si el último es un TLD compuesto (ej: .co.do), necesitamos 4+ partes para subdomain
  const lastPart = parts[parts.length - 1]
  const secondLastPart = parts[parts.length - 2]
  const isCompoundTLD = ['co', 'com', 'net'].includes(secondLastPart) && lastPart.length === 2
  
  if (isCompoundTLD && parts.length <= 3) {
    return null // No hay subdomain (ej: vitriventa.co.do)
  }
  
  // El subdomain es la primera parte
  return parts[0]
}

export const isPanelSubdomain = (): boolean => {
  const subdomain = getSubdomain()
  return subdomain === 'panel'
}

export const isAdminSubdomain = (): boolean => {
  const subdomain = getSubdomain()
  return subdomain === 'admin' || subdomain === 'superadmin'
}

export const isDashAdminSubdomain = (): boolean => {
  const hostname = window.location.hostname
  
  // En desarrollo con query param
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('admin') === 'true' || urlParams.get('dash') === 'true'
  }
  
  // En producción: detectar subdominios de admin
  const parts = hostname.split('.')
  
  if (parts.length >= 2) {
    const subdomain = parts[0]
    // Soportar: admin-dash, dash, admin, superadmin
    return subdomain === 'admin-dash' || 
           subdomain === 'dash' || 
           subdomain === 'admin' || 
           subdomain === 'superadmin'
  }
  
  return false
}

export const getMainDomain = (): string => {
  const hostname = window.location.hostname
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return hostname
  }
  
  const parts = hostname.split('.')
  
  // Si es TLD compuesto (ej: .co.do), tomar las últimas 3 partes
  const lastPart = parts[parts.length - 1]
  const secondLastPart = parts[parts.length - 2]
  const isCompoundTLD = ['co', 'com', 'net'].includes(secondLastPart) && lastPart.length === 2
  
  if (isCompoundTLD) {
    return parts.slice(-3).join('.') // dominio.co.do
  }
  
  // TLD simple, tomar las últimas 2 partes
  return parts.slice(-2).join('.') // dominio.com
}

export const buildSubdomainUrl = (subdomain: string | null, path: string = '/'): string => {
  const protocol = window.location.protocol
  const mainDomain = getMainDomain()
  
  if (subdomain) {
    return `${protocol}//${subdomain}.${mainDomain}${path}`
  }
  
  return `${protocol}//${mainDomain}${path}`
}
